import cache from '@/assets/lib/cache'
let userInfo = cache.getSession('dtit_user') || {}
let isNeed = ['dljs/0001', 'dljs/0002'].includes(userInfo.zoneChildName)
export default {
  isNeed,
  titleList: {
    mainttitle: '待办工作',
    subtitle: ['市场会议', '项目会议', '行政会议'],
    speaker: '住持人',
    time: '开始时间',
    sensor: '室内'
  }
}
